import { Empty, Flex, Typography } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { ListEmptyState } from "../../../components/Table/ListEmptyState.tsx"

const { Text } = Typography

interface SuppliersEmptyProps {
  hasSearch?: boolean
  /** The first page failed to load; an empty table then says nothing about the suppliers. */
  loadFailed?: boolean
  onRetry?: () => void
}

export function SuppliersEmpty({
  hasSearch,
  loadFailed,
  onRetry
}: SuppliersEmptyProps) {
  const { t } = useTranslation()

  if (loadFailed) {
    return (
      <ListEmptyState object="suppliers" variant="error" onRetry={onRetry} />
    )
  }

  const content = hasSearch ? (
    <Flex vertical className="text-center py-3">
      <Text type="secondary" strong>
        {t("suppliers.empty.noMatches")}
      </Text>
      <Text type="secondary" className="mt-1">
        {t("suppliers.empty.tryOtherKeywords")}
      </Text>
    </Flex>
  ) : (
    t("suppliers.empty.none")
  )

  return <Empty description={content} />
}
